<script>
  import { Pagination, TextInput } from "carbon-components-svelte";
  import { onMount } from "svelte";
  import { DataTable, Button } from "carbon-components-svelte";

  import Edit16 from "carbon-icons-svelte/lib/Edit16";
  import AnonymizationListUi from "../../damprojects-frontend/components/AnonymizationListUI.svelte";
  import download from "downloadjs";
  import Header from "lib/components/Header.svelte";
  import { escapeRegExp } from "lib/util/regex.js";
  import ButtonNew from "lib/components/ButtonNew.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import PreprocessingHeaderButtons from "./PreprocessingHeaderButtons.svelte";

  export let isCompleted;
  export let idproject;

  let idAnonymization;

  let isloading = false;

  let uipage = 1;
  let uipageSize;
  let uilist = [];
  let fulluilist = [];

  let uilistfilterelements = {
    applicationname: [],
    type: [],
    elementclass: [],
  };

  let uilistfilter = {
    applicationname: "",
    windowtitle: "",
    type: "",
    elementclass: "",
    name: "",
    automationid: "",
  };

  let anonymizationRuleModalOpenUI = false;

  let currentAnonymizationRuleUI = {
    id: 0,
    name: "",
    automationsearch: "",
    automationreplace: "",
    namesearch: "",
    namereplace: "",
    elementclass: "",
    applicationname: "",
    type: "",
  };

  //$: {
  //  if (uilistfilter) filterUIList();
  //}

  //  $: getUIElements();

  function exportPreprocessingSteps() {
    fetchWithSession(
      `/api/damprojects/exportDAMAnonymizationRuleUI/${idAnonymization}`,
    )
      .then((response) => response.blob())
      .then((data) => {
        download(data, "preprocessing.csv", "text/plain");
      });
  }
  function importPreprocessingSteps() {
    let fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".csv";
    fileInput.onchange = function () {
      let file = fileInput.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let content = e.target.result;
        importPreprocessingStepsContent(content);
      };
      reader.readAsText(file);
    };
    fileInput.click();
  }
  function importPreprocessingStepsContent(content) {
    fetchWithSession(
      `/api/damprojects/importDAMAnonymizationRuleUI/${idAnonymization}`,
      {
        method: "POST",
        body: JSON.stringify({
          file: content,
          idproject: idproject,
          projectStep: 2,
        }),
      },
    )
      .then((response) => response.text())
      .then((data) => {
        idAnonymization = idAnonymization;
      });
  }

  function filterUIList() {
    uilist = fulluilist.filter((item) => {
      let matches = true;
      const applicationName =
        item.applicationname === null ? " " : item.applicationname;
      if (uilistfilter.applicationname != "*") {
        if (uilistfilter.applicationname === " ") {
          matches =
            matches &&
            (item.applicationname === null || item.applicationname === "");
        } else {
          matches =
            matches &&
            applicationName
              .toLowerCase()
              .includes(uilistfilter.applicationname.toLowerCase());
        }
      }
      const elementClass =
        item.elementclass === null || item.elementClass === ""
          ? " "
          : item.elementclass;
      if (uilistfilter.elementclass != "*") {
        if (uilistfilter.elementclass === " ") {
          matches =
            matches && (item.elementclass === null || item.elementclass === "");
        } else {
          try {
            const elementClassRegex = new RegExp(
              uilistfilter.elementclass,
              "i",
            );
            matches = matches && elementClassRegex.test(elementClass);
          } catch (e) {
            matches = false;
          }
        }
      }
      if (uilistfilter.windowtitle != "") {
        try {
          const windowTitleRegex = new RegExp(uilistfilter.windowtitle, "i");
          matches = matches && windowTitleRegex.test(item.windowtitle);
        } catch (e) {
          matches = false;
        }
      }

      const type = item.type === null || item.type === "" ? " " : item.type;
      if (uilistfilter.type != "*") {
        if (uilistfilter.type === " ") {
          matches = matches && (item.type === null || item.type === "");
        } else {
          matches =
            matches &&
            item.type.toLowerCase().includes(uilistfilter.type.toLowerCase());
        }
      }
      if (uilistfilter.name != "") {
        if (uilistfilter.name === " ") {
          matches = matches && (item.name === null || item.name === "");
        } else {
          try {
            const nameRegex = new RegExp(uilistfilter.name, "i");
            matches = matches && nameRegex.test(item.namepreview);
          } catch (e) {
            matches = false;
          }
        }
      }
      if (uilistfilter.automationid != "") {
        if (uilistfilter.automationid === " ") {
          matches =
            matches && (item.automationid === null || item.automationid === "");
        } else {
          try {
            const automationidRegex = new RegExp(
              uilistfilter.automationid,
              "i",
            );
            matches = matches && automationidRegex.test(item.automationpreview);
          } catch (e) {
            matches = false;
          }
        }
      }
      return matches;
    });
  }

  function newRuleFromEntryUI(entry) {
    currentAnonymizationRuleUI = {
      id: 0,
      name: "",
      automationsearch: entry.automationpreview
        ? escapeRegExp(entry.automationpreview)
        : "",
      automationreplace: entry.automationpreview ? entry.automationpreview : "",
      namesearch: entry.namepreview ? escapeRegExp(entry.namepreview) : "",
      namereplace: entry.namepreview ? entry.namepreview : "",
      elementclass: entry.elementclass ? entry.elementclass : "",
      applicationname: entry.applicationname ? entry.applicationname : "",
      type: entry.type ? entry.type : "",
    };
    anonymizationRuleModalOpenUI = true;
  }

  function applyUIRules() {
    if (isloading) return;
    isloading = true;
    fetchWithSession(
      `/api/damprojects/getAnonymizationUILog?idproject=${idproject}&projectStep=2`,
    )
      .then((res) => res.json())
      .then((data) => {
        fulluilist = data.elements;
        uilistfilterelements = data.filterelements;
        uilistfilterelements = data.filterelements;
        isloading = false;
        filterUIList();
      })
      .catch((err) => {
        console.error(err);
        isloading = false;
      });
  }

  function orderElements(list) {
    if (!list) return [];
    return list.sort((a, b) => {
      const aValue = a === null ? "" : a;
      const bValue = b === null ? "" : b;
      return aValue.toLowerCase().localeCompare(bValue.toLowerCase());
    });
  }

  function displayElement(element) {
    return element === null || element === "" ? " " : element;
  }

  onMount(() => {
    fetchWithSession(`/api/damprojects/getProjectAnonymizations/${idproject}/2`)
      .then((res) => res.json())
      .then((data) => {
        idAnonymization = data;
        applyUIRules();
      });
  });

  let selectedAnonymizationRules = [];
</script>

<Header section="Preprocessing" breadcrumb="UI Elements">
  <PreprocessingHeaderButtons
    {idproject}
    {exportPreprocessingSteps}
    {importPreprocessingSteps}
  ></PreprocessingHeaderButtons>
</Header>

<div class="table_heading bold">Data</div>
<table>
  <tr>
    <td>
      <TextInput
        labelText="Application"
        size="sm"
        bind:value={uilistfilter.applicationname}
        placeholder="All Applications"
        list="Application"
      />
      <datalist id="Application">
        {#each orderElements(uilistfilterelements.applicationname) as application}
          <option value={displayElement(application)} />
        {/each}
      </datalist>
    </td>
    <td>
      <TextInput
        labelText="Class"
        size="sm"
        bind:value={uilistfilter.elementclass}
        placeholder="All Classes"
        list="Class"
      />
      <datalist id="Class">
        {#each orderElements(uilistfilterelements.elementclass) as application}
          <option value={displayElement(application)} />
        {/each}
      </datalist>
    </td>
    <td>
      <TextInput
        labelText="Type"
        size="sm"
        bind:value={uilistfilter.type}
        placeholder="All Types"
        list="Type"
      />
      <datalist id="Type">
        {#each orderElements(uilistfilterelements.type) as application}
          <option value={displayElement(application)} />
        {/each}
      </datalist>
    </td>
    <td>
      <TextInput
        labelText="Name"
        size="sm"
        bind:value={uilistfilter.name}
        placeholder="Name"
      />
    </td>
    <td>
      <TextInput
        labelText="Automation ID"
        size="sm"
        bind:value={uilistfilter.automationid}
        placeholder="Automation ID"
      />
    </td>
    <td class="button_list" style="padding-right: 0.5rem">
      <ButtonNew
        text="Add Rule"
        size="sm"
        secondary={true}
        setting={true}
        on:click={() => {
          newRuleFromEntryUI(uilistfilter);
        }}
      ></ButtonNew>
    </td>
    <td class="button_list">
      <ButtonNew
        text="Apply Filter"
        size="sm"
        secondary={true}
        setting={true}
        on:click={() => {
          filterUIList();
        }}
      ></ButtonNew>
    </td>
  </tr>
</table>

<DataTable
  size="short"
  headers={[
    { key: "applicationname", value: "Application", width: "auto" },
    { key: "elementclass", value: "Class", width: "auto" },
    { key: "type", value: "Type", width: "150px" },
    { key: "namepreview", value: "Name", width: "auto" },
    { key: "automationpreview", value: "Automation ID", width: "auto" },
    { key: "count", value: "Count", width: "100px" },
    { key: "menu", empty: true, width: "80px" },
  ]}
  rows={uilist}
  sortable
  page={uipage}
  pageSize={uipageSize}
  sortDirection="desc"
  sortKey="count"
>
  <svelte:fragment slot="cell" let:cell let:row>
    {#if cell.key === "menu" && !isCompleted}
      <Button
        size="small"
        kind="tertiary"
        icon={Edit16}
        on:click={() => {
          newRuleFromEntryUI(row);
        }}
        iconDescription="Create Rule From Entry"
      ></Button>
    {:else if cell.key !== "menu"}
      <div
        style="overflow-x:hidden; white-space:nowrap; text-overflow: ellipsis;"
        title={cell.value}
      >
        {cell.value}
      </div>
    {/if}
  </svelte:fragment>
</DataTable>
<Pagination
  totalItems={uilist.length}
  pageSizes={[10, 25, 50]}
  bind:page={uipage}
  bind:pageSize={uipageSize}
/>

<div class="button_wrapper">
  <ButtonNew
    text="Apply"
    setting={true}
    secondary={true}
    loading={isloading}
    disabled={isloading}
    on:click={() => {
      applyUIRules();
    }}
  />
</div>

<AnonymizationListUi
  {idAnonymization}
  editable={!isCompleted}
  {uilistfilterelements}
  bind:currentAnonymizationRule={currentAnonymizationRuleUI}
  bind:anonymizationRuleModalOpen={anonymizationRuleModalOpenUI}
  bind:selectedAnonymizationRules
/>

<style>
  .table_heading {
    padding-top: 2rem;
    padding-bottom: 1rem;
  }

  .button_wrapper {
    display: flex;
    align-items: center;
  }
  .button_list {
    vertical-align: bottom;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    width: 1%;
  }
</style>
